module.exports = __webpack_public_path__ + "img/box_bg6.dce29f5.png";